// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2il5k","modalFooterButton":"ModalNotes_modalFooterButton__1dhFP"};